import { RouteName } from '@/enums/route-name-type';
import { Product, ITrackingData, Tracker, Action } from '@studyportals/datalake-event-tracker';
import { StepType } from 'interfaces/enums/step-type';

export default class JourneyTracker {
	public tracker: Tracker;

	constructor() {
		this.tracker = new Tracker(Product.MY_JOURNEY, true, true);
	}

	public trackFakePageView(routeName: RouteName): void {
		const trackingData: ITrackingData = {
			category: Product.MY_JOURNEY,
			action: Action.IMPRESSION,
			label: routeName,
		};

		this.tracker.trackStructuredEvent(trackingData, JourneyLabels.VISITED_PAGE);
	}

	public trackStepCompletion(stepType: StepType): void {
		const trackingData: ITrackingData = {
			category: Product.MY_JOURNEY,
			action: Action.COMPLETED,
			label: stepType,
		};

		this.tracker.trackStructuredEvent(trackingData, JourneyLabels.COMPLETED_STEP);
	}
}

enum JourneyLabels {
	VISITED_PAGE = 'my_journey_visited_page',
	COMPLETED_STEP = 'my_journey_completed_step',
}
